import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';
import { userProfileAction } from './getUserProfile.action';

export const updateAccountInfoAction = {
    updateAccountInfoHandler
};

function updateAccountInfoHandler(data) {
    return dispatch => {
        dispatch(request());
        userProfileService.updateAccountInfoHandler(data)
            .then(
                updateAccountInfo => {
                    dispatch(userProfileAction.getUserProfileHandler())
                    dispatch(success(updateAccountInfo));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_UPDATE_ACCOUNT_PROFILE} }
    function success(updateAccountInfo) { return { type: userProfileConstants.RECEIVE_UPDATE_ACCOUNT_PROFILE, updateAccountInfo } }
    function failure(error) { return { type: userProfileConstants.UPDATE_ACCOUNT_PROFILE_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/updateAccountInfo.action.js